module.exports = __webpack_public_path__ + "img/num9.03fbbd22.svg";